import { useTranslation } from 'react-i18next';

/**
 * Live autosave status for form pages (plot beats, character levels, setup).
 * Same honesty contract as the screenplay editor's label: a permanent save
 * failure says "NOT SAVING — copy your work" instead of hiding behind a
 * retry spinner. Renders nothing until the first status arrives.
 */
export default function SaveStatusLabel({ status }) {
  const { t } = useTranslation();
  if (!status) return null;
  let text;
  let tone = 'text-muted-foreground';
  switch (status.state) {
    case 'saving':
      text = t('saveStatus_saving');
      break;
    case 'dirty':
      text = t('saveStatus_dirty');
      break;
    case 'error':
      // Permanent = a deterministic reject (session expired, changed
      // elsewhere, oversized). Retrying cannot fix it — be honest so the
      // writer protects their work instead of trusting a spinner.
      text = status.permanent ? t('saveStatus_notSaving') : t('saveStatus_retrying');
      tone = 'text-destructive';
      break;
    case 'saved':
    default:
      text = status.at
        ? t('saveStatus_savedAt', {
            time: new Date(status.at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          })
        : t('saveStatus_saved');
      break;
  }
  return (
    <span
      className={`font-mono text-[10px] uppercase tracking-widest ${tone}`}
      data-testid="form-save-status"
      title={status.error ? String(status.error.message || status.error) : undefined}
    >
      {text}
    </span>
  );
}
